// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__Ys_tD","header":"Header_header__AF_3G","title":"Header_title__a3JC3","fa-bars":"Header_fa-bars__LBaQo"};